import actions from "./actions";

const sendInvoiceToRegisteredEmail = actions.sendInvoiceToRegisteredEmail;
const sendInvoiceToNewEmail = actions.sendInvoiceToNewEmail;

export default {
  sendInvoiceToRegisteredEmail,
  sendInvoiceToNewEmail,
};
